import { Card, CardContent } from "@/components/ui/card";

export function KpiCard({ label, value, hint, accent = "primary", testid }) {
  const accentClass = {
    primary: "text-[hsl(var(--primary))]",
    accent: "text-[hsl(var(--accent))]",
    success: "text-emerald-700",
    warn: "text-amber-600",
    gold: "text-[hsl(var(--gold-foreground))]",
  }[accent] || "";
  return (
    <Card className="rounded-xl border-[hsl(var(--border))] bg-white shadow-sm" data-testid={testid}>
      <CardContent className="p-4">
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</p>
        <p className={`font-display font-semibold text-3xl mt-1 ${accentClass}`}>{value}</p>
        {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
      </CardContent>
    </Card>
  );
}
